












































import { Component, Vue } from 'vue-property-decorator';
import MinimalLayout from '@/layouts/Minimal.vue';
import StAndrewsLogo from '@/assets/img/logo_final_gold_no_title.svg';
import { Lang } from '@/lang/en/login.ts';
import Validation from '@/services/validation';
import AuthService from '@/services/auth';
import { currentAppVersion } from '@/main';

@Component({
  components: {
    MinimalLayout,
    StAndrewsLogo,
  },
})
export default class Login extends Vue {

  private lang: object = Lang;
  private appVersion: any = currentAppVersion;
  private valid: boolean = true;
  private login: object = {
    email: '',
    password: '',
  };

  private emailRules: object[] = [
    (v) => !!v || 'Email is required',
    (v) => Validation.emailAddressValidation(v) || 'Must be a valid Email-Address',
  ];

  private passwordRules: object[] = [
    (v) => !!v || 'A Password is required',
    (v) => v.length >= 8 || 'Passwords must be 8 or more',
  ];

  public submit(): void {
    AuthService.Login(this.login);
    return ;
  }

}
